import Vue from 'vue';
import VueRouter, { RouteConfig } from 'vue-router';

import QuizFeedback from '../views/QuizFeedback.vue';
import QuizIntro from '../views/QuizIntro.vue';
import QuizQuestion from '../views/QuizQuestion.vue';
import QuizResults from '../views/QuizResults.vue';

Vue.use(VueRouter);

const routes: Array<RouteConfig> = [
	{
		path: '/',
		name: 'QuizIntro',
		component: QuizIntro,
	},
	{
		path: '/question/',
		name: 'QuizQuestion',
		component: QuizQuestion,
		props: (route) => ({ selectedAnswer: route.params.selectedAnswer }),
	},
	{
		path: '/feedback/',
		name: 'QuizFeedback',
		component: QuizFeedback,
		props: (route) => ({ selectedAnswer: route.params.selectedAnswer }),
	},
	{
		path: '/results/',
		name: 'QuizResults',
		component: QuizResults,
	},
	{
		path: '*',
		redirect: '/',
	},
];

const router = new VueRouter({
	routes,
});

export default router;
